// src/pages/ReceiveDeliverySkeleton.jsx
//
// Mirrors the real layout of ReceiveDeliveryView so nothing jumps when the
// data lands: status chip, ticket panel, then the journey timeline.
// Keep the block heights roughly in sync with the real components.

import React from 'react';
import { Box, Container, Paper, Divider, Skeleton, Stack } from '@mui/material';

const TimelineRow = ({ minor = false, last = false }) => (
  <Box sx={{ display: 'flex', gap: 1.5 }}>
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: 20, flexShrink: 0 }}>
      <Skeleton variant="circular" width={minor ? 8 : 12} height={minor ? 8 : 12} sx={{ mt: 0.75 }} />
      {!last && <Box sx={{ width: 2, flex: 1, bgcolor: 'divider', my: 0.5 }} />}
    </Box>
    <Box sx={{ flex: 1, minWidth: 0, pb: last ? 0 : 2.5 }}>
      {minor ? (
        <Skeleton variant="text" width="55%" height={16} />
      ) : (
        <Stack direction="row" justifyContent="space-between" alignItems="flex-start" gap={1}>
          <Box sx={{ flex: 1 }}>
            <Skeleton variant="text" width={60} height={14} />
            <Skeleton variant="text" width="45%" height={26} />
          </Box>
          <Skeleton variant="text" width={44} height={22} />
        </Stack>
      )}
    </Box>
  </Box>
);

export function ReceiveDeliverySkeleton() {
  return (
    <Container maxWidth="sm" sx={{ py: 4, pt: 12 }}>
      <Paper
        elevation={0}
        sx={{ borderRadius: 3, border: '1px solid', borderColor: 'divider', overflow: 'hidden' }}
      >
        {/* Header */}
        <Box sx={{ px: 3, pt: 2.5, pb: 2, textAlign: 'center', bgcolor: 'primary.50' }}>
          <Skeleton variant="rounded" width={150} height={32} sx={{ mx: 'auto', borderRadius: 4 }} />
          <Skeleton variant="text" width="70%" height={16} sx={{ mx: 'auto', mt: 1.25 }} />
        </Box>

        <Divider />

        {/* Ticket panel — the tall block, so reserving it matters most */}
        <Box sx={{ px: 2, pt: 2, pb: 2.5 }}>
          <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1.25, px: 0.5 }}>
            <Skeleton variant="circular" width={18} height={18} />
            <Skeleton variant="text" width={70} height={20} />
            <Box sx={{ flex: 1 }} />
            <Skeleton variant="text" width={110} height={16} />
          </Stack>
          <Skeleton variant="rounded" height={280} sx={{ borderRadius: 2 }} />
        </Box>

        <Divider />

        {/* Journey */}
        <Box sx={{ px: 3, py: 3 }}>
          <TimelineRow />
          <TimelineRow minor />
          <TimelineRow minor />
          <TimelineRow last />
        </Box>

        <Divider />

        {/* Package row */}
        <Box sx={{ px: 3, py: 2 }}>
          <Skeleton variant="text" width="40%" height={20} />
        </Box>
      </Paper>
    </Container>
  );
}

export default ReceiveDeliverySkeleton;